// HOIAN TRACKING ACTION TYPE
export const SUBSCRIBE_TRACKING_CODE = '10'
export const EXIT_INTENT_TRACKING_CODE = '11'
export const POPUP_TRACKING_CODE = '12'
export const TOAST_TRACKING_CODE = '13'
export const POPUP_ENRICH_DATA_TRACKING_CODE = '24'
export const CLOSE_POPUP_ENRICH_DATA_CODE = '25'
export const SHOW_POPUP_ENRICH_DATA_CODE = '26'

// API
export const API_HOST = 'https://beta-be.mcm.hoian.ai/api/v1'
export const WELCOME_PUSH_MASSAGE_URL = `${API_HOST}/action-triggers/public/welcome_push?channel=toast`
export const POPUP_CHANNEL_URL = `${API_HOST}/customer-journeys/public/onsite_push?tracking_id=`

// COOKIE KEY
export const COOKIE_WELCOME_PUSH_KEY = 'welcome_push'
export const COOKIE_DEFAULT_KEY = 'exit_intent'
// STORAGE KEY
export const WELCOME_PUSH_DATA_KEY = 'welcome_push_data'
export const PAGE_DEACTIVATED_KEY = 'page_deactivated'
export const PAGE_DEACTIVATED_EVENT_SENT_KEY = 'page_deactivated_event_sent'
export const POPUP_KEY = 'popup'
export const ACTION_MANAGER_KEY = 'ActionManager'
export const EXIT_INTENT_SESSION_UUID = 'kariba_exit_intent_session_uuid'
export const SEND_TOKEN_SESSION_UUID = 'kariba_send_token_kariba_session_uuid'
// ==== SENSIBILITY
export const useLessVar = 1
export const MOBILE_SCROLL_SENSIBILITY = -200
export const DESKTOP_SCROLL_SENSIBILITY = 300
// TIMEOUT
export const MODAL_TIMEOUT = 700 // 2s
export const TOAST_SHOW_TIME = 5000 // 2s
export const TOAST_HIDE_TIME = 10000 // 2s
export const WELCOME_PUSH_MASSAGE_TIMEOUT = 5000 // 5s
export const CHECK_PAGE_DEACTIVATED_TIMEOUT = 1000
export const SHOW_MINIGAME_TIMEOUT = 10000
export const TIME_SHOW_POPUP = 172800000 //48h
// export const TIME_SHOW_POPUP = 60000 //1p

// COOKIE EXPIRED DAYS
export const WELCOME_PUSH_EXPIRED_DAYS = 365

// ! GiayDepMienTay webpush config
const WP_CONFIG_testing = {
  vapidKey:
    'BKAPhH4885oIbsZuL1MJOIaXiFDsC1Bj0sXVLtvb9xxhGdaQkeooGBJagxmlENtyg11W-5E9MO-WrnaJ4HjhBTE',
  firebaseConfig: {
    apiKey: 'AIzaSyD0G1hQlJVLqjwEGOLqpqjkb0UAqZmY0ew',
    authDomain: 'giaydep-mientay.firebaseapp.com',
    projectId: 'giaydep-mientay',
    storageBucket: 'giaydep-mientay.appspot.com',
    messagingSenderId: '661016963585',
    appId: '1:661016963585:web:0230ddf379f1f2630b2e00',
    measurementId: 'G-1PJBB5BK02',
  },
  swRegisterUrl: 'https://staging-juno-recommender.hoian.ai/firebase-messaging-sw.js',
}

// ! Juno Staging webpush config
const WP_CONFIG_staging = {
  vapidKey:
    'BMyPyP4Jf8eRwb7BXdJybUseX6J917ira7a2EPnawa-i6Ln23GDPlnd2sfb8Yegob3hQrvk9bMEWZ-OJ9SDFHg0',
  firebaseConfig: {
    apiKey: 'AIzaSyBS_6WyTh9YUaGuvodvCen11U3Lgt68PWI',
    authDomain: 'kariba-staging-juno.firebaseapp.com',
    projectId: 'kariba-staging-juno',
    storageBucket: 'kariba-staging-juno.appspot.com',
    messagingSenderId: '502807836099',
    appId: '1:502807836099:web:64b6f5e637ea423936b976',
    measurementId: 'G-WRSQSW2ZB6',
  },
  swRegisterUrl: 'https://juno-2.myharavan.com/apps/hrvsw/firebase-messaging-sw.js',
}

export const WP_CONFIG_production = {
  vapidKey:
    'BAcmTcgVB9SfbsAikV7-Am93LByFZYIf6JFvy-xi1Fn_j4IwjOdsEEGRHkagHRcj8UFWgisT795OgMjsQ0G8GAM',
  firebaseConfig: {
    apiKey: 'AIzaSyBib_lnR_UYqVce2a7CQho170PjcdzJup0',
    authDomain: 'kariba-a25bc.firebaseapp.com',
    projectId: 'kariba-a25bc',
    storageBucket: 'kariba-a25bc.appspot.com',
    messagingSenderId: '872802822624',
    appId: '1:872802822624:web:1106039faddaf64336e385',
    measurementId: 'G-4WSSB12ET5',
  },
  swRegisterUrl: 'https://juno.vn/apps/hrvsw/kariba-sdk.js',
}
export const KARIBA_DEPENDENCIES = []

export const MOBILE_PRE_DEFINED = {
  low: {},
  medium: {
    scrolling: {
      sensibility: MOBILE_SCROLL_SENSIBILITY,
      comparator: '<',
      timeout: 2000,
    },
    closeTab: {},
    reloadPage: {},
    changeTab: {},
    mouseOutViewPort: {},
  },
  high: {},
}
export const DESKTOP_PRE_DEFINED = {
  low: {},
  medium: {
    scrolling: {
      sensibility: 350,
      comparator: '>',
      timeout: 2000,
    },
    closeTab: {},
    reloadPage: {},
    changeTab: {},
    mouseOutViewPort: {},
  },
  high: {},
}

export const GIFT_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALFSURBVHgB7VbBbtpAEB3bqGeqXithuFW9cGxvDnAnkVqpt8AXpKgf0PAFNF8QODdVyaknMMfe4vwA3kr9AM6RwH0Tr1tD67WpXG2J9kmrtZfZN2/GsztYVACe51Vt2+5ZltXFaxOjyut4D6IoCvB4PZvNprQHwOlVKpUu9jOfK/lWzLderycLoAiPVcSR4ziXiRMFBMYCzofwLbKMWq0WJ+KM4kSoMAbXAFwrlZGt+rHdbh9DvE+x+AWy0wdpHdm2MD+GkCOsDfBbIG16bA+Rb3e5kAcXfD72cDKa2MfCLjBOmJNHwochJNcl5SDzC7DDRDwIh/P5/JwU6HQ6Hux6eDyVS1OI6nMGwdWUXFUpfAC+sco3SvYGAbG9C9tvWbZO1g+NRuMYBD08LkDQpxwsl0sRhuG0Xq+zsyb2voCIN7Va7Rbiv1B8bqabzebI9/2vKi4hxMp13Wfg4DK7BW+QZZtZQojck/M17QHOLIuUZeCmMj9E6Z3k1fRPYbZd4xlcQmlH+SjkMA0+xDKIZO8irwTT4BLiiZOQdxtlBsBXpJxP6e9Q5Rr+peleVC5SZ48xybPPDAAZHMsMen+6VXKJbdtLv0NULgeLR2/4TPHFIYp8tcwAZK0O+RmZHCGI97QHZINiJA2uq7JPbirex+K5BKkAlGcAGfgA8UkQ57jHQ3ZEBcBdtYgdd3lODsTfUNxLAhavaoZbfooYcUNDVkYQ5colbmoTOJpm3SqyL/ippTFuoX5aOMrsDJxcWslZuYDNXuVq3X16EmJy6SARCftwxTMst0gf+K9hAtANE4Bu2HwV0cEiEr81srtXTyMqCc7rwf28/jiisvDo6vuWZnMGdMMEoBsmAN0wAeiGCUA3KrsLSfsvA9bzlzEnlYird1uvD+8LlPnHy/kHnLswh1g3TAC6YQLQDROAbpgAdMMEoBsmAN34AdYURJ2ZkxB7AAAAAElFTkSuQmCC'
export const DEFAULT_SPIN_GAME_DATA = {
  data: {
    mainPopup: {
      imgGift: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/b08b366f-238c-473d-abcf-211510b91c8e',
      },
      imgArrow: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/a9a71b30-abfb-4cf0-a0ff-10786507743b',
      },
      background: {
        url: 'https://storage.googleapis.com/dreamf-mcm-public-storage/product-images/b4302511-2b0e-4ed3-90f2-fb4e786e247d',
        backgroundSize: 'cover',
        opacity: 1,
        color: '#FFFFFF',
        timeOnSite: 5,
        products: 3,
        time: 50,
      },
      text: {
        content: 'SIÊU SALE NGÀY 11 - 11',
        style: {
          fontFamily: 'Inter',
          color: '#FA541C',
          fontSize: 36,
          fontStyle: 'bold',
          textAlign: 'left',
          opacity: 1,
        },
      },
      text_1: {
        content: 'XOAY LÀ TRÚNG NGAY',
        style: {
          fontFamily: 'Inter',
          color: '#fa541c',
          fontSize: 20,
          fontStyle: 'bold',
          textAlign: 'left',
          opacity: 1,
        },
      },
      text_2: {
        content:
          'Nhiều phần quà may mắn đang chờ đón bạn mùa siêu sale 11.11 năm nay. Bạn có 1 lượt quay, đừng bỏ lỡ nhé!',
        style: {
          fontFamily: 'Inter',
          color: '#000000',
          fontSize: 14,
          fontStyle: 'normal',
          textAlign: 'left',
          opacity: 1,
        },
      },

      input: {
        content: 'Email của bạn',
        background: {
          backgroundColor: 'white',
          opacity: 1,
        },
        style: {
          fontFamily: 'Inter',
          color: '#fffff',
          fontSize: 14,
          fontStyle: 'normal',
          textAlign: 'left',
          opacity: 1,
        },
        errorTextColor: '#F5222D',
      },
      button: {
        content: 'Bắt đầu xoay',
        buttonStyle: {
          hover: '#D4380D',
          opacity: 1,
        },
        style: {
          fontFamily: 'Inter',
          backgroundColor: '#FA541C',
          color: 'white',
          fontSize: 14,
          fontStyle: 'normal',
          textAlign: 'center',
          opacity: 1,
        },
      },

      wheel: {
        numberOptions: 6,
        textColor: '#FFFFFF',
        wheels: [
          { title: '15% OFF 1 ', color: '#FA541C', code: '', rate: '0.00' },
          { title: '15% OFF 2 ', color: '#FAAD14', code: '', rate: '0.00' },
          { title: '15% OFF 3', color: '#FA541C', code: '', rate: '0.00' },
          { title: '15% OFF 4', color: '#FAAD14', code: '', rate: '90.00' },
          { title: '15% OFF 5', color: '#FA541C', code: '', rate: '0.00' },
          { title: '15% OFF 6', color: '#FAAD14', code: '', rate: '0.00' },
          { title: '15% OFF 7', color: '#FAAD14', code: '', rate: '0.00' },
          { title: '15% OFF 8', color: '#FAAD14', code: '', rate: '10.00' },
        ],
        effect: {
          spinTime: 4,
          movement: 4,
          acceleration: 4,
        },
      },
    },
    minimize: {
      background: {
        url: 'https://storage.googleapis.com/dreamf-mcm-public-storage/product-images/b4302511-2b0e-4ed3-90f2-fb4e786e247d',
        backgroundSize: 'cover',
        opacity: 1,
      },
      text: {
        content: 'SALE NGÀY 11 - 11',
        style: {
          fontFamily: 'Inter',
          color: '#FA541C',
          fontSize: 14,
          fontStyle: 'bold',
          textAlign: 'center',
          opacity: 1,
        },
      },
    },
    result: {
      imgGift: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/b08b366f-238c-473d-abcf-211510b91c8e',
      },
      background: {
        url: 'https://storage.googleapis.com/dreamf-mcm-public-storage/product-images/b4302511-2b0e-4ed3-90f2-fb4e786e247d',
        backgroundSize: 'cover',
        opacity: 1,
        effects: 'Confetti',
      },
      text: {
        content: 'Chúc mừng bạn đã nhận',
        style: {
          fontFamily: 'Inter',
          color: '#FA541C',
          fontSize: 28,
          fontStyle: 'bold',
          textAlign: 'center',
        },
      },
      code: {
        content: '{{coupon_title}}',
        style: {
          fontFamily: 'Inter',
          color: '#FA541C',
          fontSize: 28,
          fontStyle: 'bold',
          textAlign: 'center',
        },
      },
      text_2: {
        content: 'Code đã được gửi đến Email của bạn rồi đấy',
        style: {
          fontFamily: 'Inter',
          color: '#000000',
          fontSize: 16,
          fontStyle: 'bold',
          textAlign: 'center',
          opacity: 1,
        },
      },
      button: {
        content: 'Tiếp tục mua sắm',
        buttonStyle: {
          hover: '#D4380D',
          backgroundColor: '#FA541C',
        },
        style: {
          fontFamily: 'Inter',
          backgroundColor: '#FA541C',
          color: '#FFFFFF',
          fontSize: 14,
          fontStyle: 'bold',
          textAlign: 'center',
        },
      },
    },
    email: {
      emailData: {
        subject: '123',
        email_type: 'sendgrid',
        utm_medium: '123',
        utm_source: '123',
        template_id: 'd-f2a197a4368c4a918eeb80d66088cb22',
        utm_campaign: '123',
      },
    },
  },
  popupType: 'spin-game',
  node_uuid: '1234',
}

//=====================================================

export const EXAMPLE_DATA_DEFAULTCODE = {
  popupType: 'default_code',
  node_uuid: '1',
  data: {
    mainPopup: {
      imgGift: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/f5372209-093b-49b8-921f-28b5a3babdc7',
      },
      background: {
        url: ' https://storage.googleapis.com/tch-mcm-public-storage/product-images/f5372209-093b-49b8-921f-28b5a3babdc7',
        backgroundSize: 'cover',
        opacity: 1,
        color: '#FFFFFF',
      },
      text: {
        content: 'TẶNG VOUCHER',
        style: {
          fontFamily: 'Inter',
          color: '#000',
          fontSize: 20,
          fontStyle: 'bold',
          textAlign: 'center',
          opacity: 1,
        },
      },
      text_1: {
        content: '20%',
        style: {
          fontFamily: 'Inter',
          color: '#FF0000',
          fontSize: 70,
          fontStyle: 'bold',
          textAlign: 'center',
          opacity: 1,
        },
      },
      text_2: {
        content: 'Khi đăng ký email của bạn',
        style: {
          fontFamily: 'Inter',
          color: '#000000',
          fontSize: 14,
          fontStyle: 'normal',
          textAlign: 'center',
          opacity: 1,
        },
      },

      input: {
        content: 'Email của bạn',
        background: {
          backgroundColor: 'white',
          opacity: 1,
        },
        style: {
          fontFamily: 'Inter',
          backgroundColor: 'white',
          color: '#fffff',
          fontSize: 12,
          fontStyle: 'normal',
          textAlign: 'left',
          opacity: 1,
        },
      },
      text_3: {
        content: 'Email không hợp lệ!!',
        style: {
          fontFamily: 'Inter',
          color: '#F5222D',
          fontSize: 22,
          fontStyle: 'normal',
          textAlign: 'center',
          opacity: 1,
        },
      },
      button: {
        content: 'Nhận voucher',
        buttonStyle: {
          hover: '#ccc',
          opacity: 1,
        },
        style: {
          fontFamily: 'Inter',
          backgroundColor: '#FA541C',
          color: 'white',
          fontSize: 14,
          fontStyle: 'normal',
          textAlign: 'center',
          opacity: 1,
        },
      },
    },
    minimize: {
      background: {
        url: ' https://storage.googleapis.com/tch-mcm-public-storage/product-images/f5372209-093b-49b8-921f-28b5a3babdc7',
        backgroundSize: 'cover',
        opacity: 1,
      },
      text: {
        content: 'SALE NGÀY 11 - 11',
        style: {
          fontFamily: 'Inter',
          color: '#FA541C',
          fontSize: 14,
          fontStyle: 'bold',
          textAlign: 'center',
          opacity: 1,
        },
      },
    },
    result: {
      text: {
        content: 'Cảm ơn bạn',
        style: {
          fontFamily: 'Inter',
          color: '#000',
          fontSize: 28,
          fontStyle: 'bold',
          textAlign: 'center',
          opacity: 1,
        },
      },
      background: {
        url: ' https://storage.googleapis.com/tch-mcm-public-storage/product-images/f5372209-093b-49b8-921f-28b5a3babdc7',
        backgroundSize: 'cover',
        opacity: 1,
        effects: 'Confetti',
      },
      text_1: {
        content: 'Mã khuyến mãi đã được gửi vào email của bạn rồi đấy, bạn kiểm tra nhé!',
        style: {
          fontFamily: 'Inter',
          color: '#000000',
          fontSize: 16,
          fontStyle: 'normal',
          textAlign: 'center',
          opacity: 1,
        },
      },
      button: {
        content: 'Tiếp tục mua sắm',
        buttonStyle: {
          hover: '#ccc',
          backgroundColor: '#FA541C',
        },
        style: {
          fontFamily: 'Inter',
          backgroundColor: '#FA541C',
          color: '#FFFFFF',
          fontSize: 12,
          fontStyle: 'bold',
          textAlign: 'center',
        },
      },
    },
  },
}

//=====================================================

export const EXAMPLE_DATA_RANDOMGIFT = {
  data: {
    email: {
      emailData: {
        subject: '123',
        email_type: 'sendgrid',
        utm_medium: '123',
        utm_source: '123',
        template_id: 'd-f2a197a4368c4a918eeb80d66088cb22',
        utm_campaign: '123',
      },
    },
    result: {
      text: {
        style: {
          color: '#000',
          fontSize: 20,
          fontStyle: 'bold',
          textAlign: 'center',
          fontFamily: 'Inter',
        },
        content: 'Chúc mừng bạn đã nhận',
      },
      button: {
        style: {
          color: '#FFFFFF',
          width: 232,
          height: 40,
          fontSize: 12,
          fontStyle: 'bold',
          textAlign: 'center',
          fontFamily: 'Inter',
          backgroundColor: '#FA541C',
        },
        content: 'Tiếp tục mua sắm',
        buttonStyle: {
          hover: '#ccc',
          backgroundColor: '#FA541C',
        },
      },
      text_1: {
        style: {
          color: '#000000',
          opacity: 1,
          fontSize: 16,
          fontStyle: 'normal',
          textAlign: 'center',
          fontFamily: 'Inter',
        },
        content: 'Mã khuyến mãi đã được gửi vào email của bạn rồi đấy, bạn kiểm tra nhé!',
      },
      imgGift: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/2e2d2df1-19e1-431a-b29d-78fda4426c29',
      },
      background: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/f5372209-093b-49b8-921f-28b5a3babdc7',
        color: '#F0F5FF',
        effects: 'Confetti',
        opacity: 1,
        backgroundSize: 'cover',
      },
    },
    minimize: {
      text: {
        style: {
          color: '#000',
          opacity: 1,
          fontSize: 14,
          fontStyle: 'bold',
          textAlign: 'center',
          fontFamily: 'Inter',
        },
        content: 'Bạn có muốn nhận quà?',
      },
      background: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/d5e1afdf-db0b-43fa-a6d5-98f6a134a188',
        opacity: 1,
        backgroundSize: 'cover',
      },
    },
    mainPopup: {
      gift: {
        gifts: [
          {
            code: 'DISCOUNT15',
            title: 'Title1',
          },
          {
            code: 'DISCOUNT15',
            title: 'Title1',
          },
          {
            code: 'DISCOUNT15',
            title: 'Title2',
          },
          {
            code: 'DISCOUNT30',
            title: 'Title3',
          },
          {
            code: 'DISCOUNT30',
            title: 'Title4',
          },
        ],
        effect: {},
        numberOptions: 1,
      },
      text: {
        style: {
          color: '#000',
          weight: '600',
          opacity: 1,
          fontSize: 20,
          fontStyle: 'bold',
          textAlign: 'center',
          fontFamily: 'Inter',
        },
        content: 'Bạn có muốn nhận quà?',
      },
      input: {
        style: {
          color: '#fffff',
          opacity: 1,
          fontSize: 14,
          fontStyle: 'normal',
          textAlign: 'left',
          fontFamily: 'Inter',
        },
        content: 'Email của bạn',
        background: {
          opacity: 1,
          backgroundColor: 'white',
        },
      },
      text_1: {
        style: {
          color: '#000',
          opacity: 1,
          fontSize: 16,
          fontStyle: 'normal',
          textAlign: 'center',
          fontFamily: 'Inter',
        },
        content: 'Nhập email và chọn ngẫu nhiên một món quà dành riêng cho bạn',
      },
      imgGift: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/2e2d2df1-19e1-431a-b29d-78fda4426c29',
      },
      background: {
        url: 'https://storage.googleapis.com/tch-mcm-public-storage/product-images/f5372209-093b-49b8-921f-28b5a3babdc7',
        color: '#F0F5FF',
        opacity: 1,
        backgroundSize: 'cover',
      },
    },
  },
  popupType: 'random_gift',
  node_uuid: '123',
}

//=====================================================

export const DEFAULT_WHEEL_DATA = {
  canvasId: 'kariba_popup_canvas',
  numSegments: 3, // Specify number of segments.
  outerRadius: 155, // Set radius to so wheel fits the background.
  innerRadius: 16, // Set inner radius to make wheel hollow.
  textFontSize: 16, // Set font size accordingly.
  textMargin: 0, // Take out default margin.
  lineWidth: 0,
  // Define segments including colour and text.
  segments: [
    {
      fillStyle: '#eae56f',
      text: 'Prize 1',
      code: 'xxx',
      strokeStyle: '#ffffff',
    },
    {
      fillStyle: '#89f26e',
      text: 'Prize 2',
      code: 'xxx',
      strokeStyle: '#ffffff',
    },
    {
      fillStyle: '#7de6ef',
      text: 'Prize 3',
      code: 'xxx',
      strokeStyle: '#ffffff',
    },
  ],
}
export const Default_data_customize = {
  go_back_button_label: 'Shopping tiếp thôi',
  go_back_button_url: 'https://www.facebook.com',
  headline: 'Khoan đã, hình như bạn quên sử dụng voucher...',
  htmlTemplate:
    '<div class="PopupPreviewComponent" style="backdrop-filter: blur(30px); padding: 10px; display: flex; flex-direction: column; align-items: center; position: relative; border: 1px solid rgb(255, 255, 255); box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 15px; background: white; text-align: center; height: fit-content; min-width: 100%;"><h1 class="headline" style="font-size: 16px; font-weight: 700;">Khoan đã, hình như bạn quên sử dụng voucher...</h1><div class="promo-content"><h2 class="title" style="font-size: 40px; margin: 5px; color: rgb(222, 72, 98); text-shadow: rgba(0, 0, 0, 0.05) -3px 3px 5px;">GIẢM ĐẾN 20%!!!</h2><p class="description" style="font-size: 14px; line-height: 20px;">Tiếp tục mua hàng và sử dụng mã <span style="\n        background: #f4cd7a;\n        border-radius: 2px;\n        padding: 2px;\n        color: white;\n        font-weight: 700">MUAHANGLANDAU</span> để được giảm 20% cho lần mua hàng đầu tiên bạn nhé</p></div><div class="promo-footer"><a href="https://www.facebook.com" class="go-back-btn" style="font-size: 12px; padding: 8px; font-weight: 700; background: linear-gradient(450deg, rgb(222, 72, 98) 0px, rgb(255, 112, 129) 100%); min-width: 100px; min-height: 30px; box-shadow: rgb(222, 72, 98) 0px 0px 10px; display: flex; justify-content: center; color: white; box-sizing: border-box; margin: 10px; cursor: pointer;">Shopping tiếp thôi</a></div></div>',
  popupType: 'customize',
  promo_content:
    'Tiếp tục mua hàng và sử dụng mã {{MUAHANGLANDAU}} để được giảm 20% cho lần mua hàng đầu tiên bạn nhé',
  promo_title: 'GIẢM ĐẾN 20%!!!',
}

///
export const POPUP_TEST = {
  popupType: 'customize',
  htmlTemplate: `<div style="position: relative; width:600px"> 
  <img  style="max-width: 600px" src="https://storage.googleapis.com/dreamf-mcm-public-storage/product-images/8f10a20b-84d0-4551-ac48-5808b30886a7" >
  <div style="position: absolute; bottom: 8%; width: 100%;left: 40%">
  <a style="
    border-radius: 10px;
    background-color:#FA4420;
    color: #FEF147;
    padding: 4px 8px;
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 12px;
    text-decoration: none;
  " href="https://juno.vn/collections/flash-sale-quan-ao?itm_source=krb&itm_medium=Popup_Onsite&itm_campaign=JA_O1_o.BC_Middle_23Apr_ChillingSale_s.User_L1.VN00_19042023_SaleDongGia
">GHÉ XEM NGAY</a>
  </div>
</div>
`,
  node_uuid: '123',
}
